import { render, staticRenderFns } from "./organization-datasource-datasubject-form.vue?vue&type=template&id=f149d1a4"
import script from "./organization-datasource-datasubject-form.vue?vue&type=script&lang=js"
export * from "./organization-datasource-datasubject-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports